export default "__VITE_ASSET__uvG9BV8T__"